<h1 class="harp-card-title">Warning</h1>
<p>
  Your password expires soon. Do you want to change your password or continue
  with your current password?
</p>
<p>
  <button type="button" (click)="changePwdCheck()" class="btn btn-primary">
    Change Password
  </button>
</p>
<p>
  <button class="link" (click)="ignorePwdCheck()">
    Continue with Current Password
    <strong class="icon ion-md-arrow-round-forward"></strong>
  </button>
</p>
